import React, { FC } from 'react';
import classNames from 'classnames';
import { InsuranceFormSubmissionStatus } from '../Utils/types';

interface FormSubmittedStatusProps {
  status: InsuranceFormSubmissionStatus;
  successMessage: string;
  errorMessage: string;
}

export const FormSubmittedStatus: FC<FormSubmittedStatusProps> = (props) => {
  const { status, successMessage, errorMessage } = props;

  const getMessage = () => {
    return status === "success"
      ? successMessage
      : errorMessage
  }

  return (
    <div className={classNames("formSubmittedStatus", {
      "formSubmittedStatus--success": status === "success",
      "formSubmittedStatus--error": status === "error"
    })}>
      <span className="formSubmittedStatus__label">
        {getMessage()}
      </span>
    </div>
  )
};
